import {HTTP_STATUS_ABORTED, HttpError} from 'api/http/types';

type RtkLazyTriggerResult<T> = {
  unwrap: () => Promise<T>;
  abort: () => void;
};

/**
 * Bridges an RTK Query lazy trigger promise to the existing AbortSignal-based
 * contract used by the entity search hooks. On abort the rejection is
 * normalized to an HttpError(299) so the caller's catch logic keeps working
 * unchanged.
 */
export const runLazyTriggerAsAbortable = async <T>(
  promise: RtkLazyTriggerResult<T>,
  signal: AbortSignal,
): Promise<T> => {
  const onAbort = () => promise.abort();
  signal.addEventListener('abort', onAbort, {once: true});
  try {
    return await promise.unwrap();
  } catch (error) {
    if (signal.aborted) {
      throw new HttpError(HTTP_STATUS_ABORTED, '', 'Aborted');
    }
    throw error;
  } finally {
    signal.removeEventListener('abort', onAbort);
  }
};
